import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-new',
  templateUrl: './add-new.component.html',
  styleUrls: ['./add-new.component.scss'],
})
export class AddNewComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  EPPNew: FormGroup;
  submitted = false;
  isLoading: boolean;
  keyword = 'UserName';
  currentUser: any;
  baseDocType:any;
  constructor(
    private fb: FormBuilder,
    private gs: GeneralService,
    private router: Router
  ) {}
  columns = ['User Id', 'User Name', 'Email ID', 'Mobile No'];

  index = ['UserID', 'UserName', 'EmailID', 'MobileNo'];
  
  users = [];

  ngOnInit() {
    this.currentUser = this.gs.getcurrentUser()
    this.breadCrumbItems = [
      { label: 'EPP', path: '/' },
      { label: 'Add', path: '/add-new', active: true },
    ];
    this.EPPNew = this.fb.group({
      district: new FormControl('', Validators.required),
      taluka: new FormControl(''),
      village: new FormControl(''),
      StateID: new FormControl(7),
      survey_number: new FormControl('', Validators.required),
      start_date: new FormControl('', Validators.required),
      end_date: new FormControl('', Validators.required),
      user_id: new FormControl('', Validators.required),
      // group_id: new FormControl(''),
      uname: new FormControl('', Validators.required),
      Admin_ID: new FormControl(this.currentUser.Id),
      BaseDocument: new FormControl(null, Validators.required),
      citysurveyoffice: new FormControl(''),
      ward: new FormControl(''),
      sheetno: new FormControl(''),
      EPP_In_Days: new FormControl(30, [Validators.min(0),Validators.required]),
    },
    { validators: this.startDateBeforeEndDateValidator });
  }
  startDateBeforeEndDateValidator(control: AbstractControl): ValidationErrors | null {
    const startDate = control.get('start_date').value;
    const endDate = control.get('end_date').value;

    if (startDate && endDate && startDate > endDate) {
      return { startDateAfterEndDate: true };
    }
    return null;
  }
  selectEvent(e) {
    this.EPPNew.controls['uname'].setValue(e.UserName + ' - ' + e.UserID);
    if (e) {
      this.EPPNew.controls['user_id'].setValue(e.UserID);
    } else {
      this.EPPNew.controls['user_id'].setValue(null);
    }
  }
  onChangeSearch(e: string) {
    this.gs.getEppUserid(`?UserName=${e}`).subscribe((Response: any) => {
      this.users = Response.data;
    },(error) => {                              //Error callback
      this.isLoading = false;
      Swal.fire({
        title: error.status,
        text: "Internal Server Error",
        type: "error",
      });
      //throw error;   //You can also throw the error to a global error handler
    });
  }
  onChangeBaseDocType() {
    this.baseDocType = this.EPPNew.controls.BaseDocument.value;
    if(this.baseDocType === '0') {
      this.EPPNew.get('taluka').setValidators([Validators.required]);
      this.EPPNew.get('village').setValidators([Validators.required]);
      this.EPPNew.get('citysurveyoffice').clearValidators();
      this.EPPNew.get('ward').clearValidators();
      this.EPPNew.get('sheetno').clearValidators();
      this.EPPNew.get('taluka').updateValueAndValidity();  
      this.EPPNew.get('village').updateValueAndValidity();  
      this.EPPNew.get('citysurveyoffice').updateValueAndValidity();  
      this.EPPNew.get('ward').updateValueAndValidity();  
      this.EPPNew.get('sheetno').updateValueAndValidity();  
    } else if(this.baseDocType === '1') {
      this.EPPNew.get('citysurveyoffice').setValidators([Validators.required]);
      this.EPPNew.get('ward').setValidators([Validators.required]);
      this.EPPNew.get('sheetno').setValidators([Validators.required]);
      this.EPPNew.get('taluka').clearValidators();
      this.EPPNew.get('village').clearValidators();
      this.EPPNew.get('citysurveyoffice').updateValueAndValidity();  
      this.EPPNew.get('ward').updateValueAndValidity();  
      this.EPPNew.get('sheetno').updateValueAndValidity();  
      this.EPPNew.get('taluka').updateValueAndValidity();  
      this.EPPNew.get('village').updateValueAndValidity();  
    }    
  }
  get f() {
    return this.EPPNew.controls;
  }
  onSubmit() {
    
    if(this.baseDocType === '1' && this.EPPNew.valid) {
      this.EPPNew.controls.citysurveyoffice.setValue(this.EPPNew.controls.citysurveyoffice.value.trim());
      this.EPPNew.controls.ward.setValue(this.EPPNew.controls.ward.value.trim());
      this.EPPNew.controls.sheetno.setValue(this.EPPNew.controls.sheetno.value.trim());
    } else if(this.baseDocType === '0' && this.EPPNew.valid){
      this.EPPNew.controls.taluka.setValue(this.EPPNew.controls.taluka.value.trim());
      this.EPPNew.controls.village.setValue(this.EPPNew.controls.village.value.trim());
      
    }
    this.EPPNew.controls.district.setValue(this.EPPNew.controls.district.value.trim());
    this.EPPNew.controls.survey_number.setValue(this.EPPNew.controls.survey_number.value.trim()); 
    if(typeof(this.EPPNew.controls.uname.value) === 'string') {
      this.EPPNew.controls['user_id'].setValue(null);
      this.EPPNew.controls.uname.setValue(this.EPPNew.controls.uname.value.trim());
    }
    this.submitted = true;
    if (this.EPPNew.valid) {
      // 1 is Property ID
      this.isLoading = true;
      this.gs.AddNew(this.EPPNew.value).subscribe((data) => {
        this.isLoading = false;

        if (data.status === 200) {
          this.submitted = false;
          Swal.fire({
            title: 'EPP Uploaded',
            text: data.message,
            type: 'success',
          }).then(() => {
            this.submitted = false;
            // this.reFresh.emit();
            this.router.navigate(['/epp/view/' + this.EPPNew.value.user_id]);
          });
        } else {
          Swal.fire({
            text: data.Message,
            type: 'info',
          });
        }
      },(error) => {                              //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });
    }
  }

  SetEndDate() {
    var date = new Date(this.EPPNew.controls.start_date.value);
    this.EPPNew.controls.end_date.setValue(this.add_years(date, 1).toISOString().substr(0, 10));
  }

  add_years(dt,n) 
  {
    return new Date(dt.setFullYear(dt.getFullYear() + n));      
  }
}


